const types = {
  SET_CURRENT_CANDIDATE: 'SET_CURRENT_CANDIDATE'
};
const state = {
  currentCandidate: null
};

const mutations = {
  [types.SET_CURRENT_CANDIDATE]: (state, value) => {
    state.currentCandidate = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
